<template>
  <v-app>
    <Navigation :isAuthorized="isAuthorized" @change-menu-width="menuWidth = $event" />
    <v-main style="overflow-y: hidden">
      <v-container fluid class="pa-0 router-container">
        <!-- <keep-alive include="products-zarbo"> -->
        <router-view></router-view>
        <!-- </keep-alive> -->
      </v-container>
    </v-main>

    <notifications group="foo" class="zarbo-notifications mb-1" :width="360" :duration="6000">
      <template #body="{ item, close }">
        <div class="zarbo-notifications__wrapper">
          <div class="zarbo-notifications__content">
            <div class="d-flex align-center justify-start">
              <v-icon v-if="item.type === 'success'" color="#27A37E" class="mr-4" size="24" icon="success" />
              <v-icon v-if="item.type === 'error'" color="error" class="mr-4" size="24" icon="error" />
              <div>
                <div class="d-flex align-center">
                  <h5 class="zarbo-notifications__title">
                    {{ item.title }}
                  </h5>
                  <v-btn icon class="zarbo-notifications__button-close" variant="text" @click="close">
                    <v-icon color="text" size="14" icon="closeRounded" />
                  </v-btn>
                </div>
                <p class="zarbo-notifications__text" v-html="item.text"></p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
    <DeveloperTools v-if="isDev" />
  </v-app>
</template>

<script>
// TODO: Убрать в будущем если не будем использовать.
// import { getYoutubePlaylist } from "@/components/service/api.js";
import { mapState } from "pinia";
import { defineAsyncComponent } from "vue";

import {
  useAppStore,
  useCollectionsStore,
  usePermissionsStore,
  useProductsStore,
  useTeamStore,
  useUserStore,
} from "@/store/modules";

import Navigation from "./components/Navigation/Navigation.vue";
import { initializeTeamContext } from "./services/teamContext/initializeTeamContext";

export default {
  name: "App",
  components: {
    Navigation,
    DeveloperTools: defineAsyncComponent(() => import("@/components/Utils/DeveloperTools.vue")),
  },
  data: () => ({
    refreshInterval: 0.5, // минуты
    refreshTimer: null,
    isConfirmEditCollection: false,
    isConfirmDeleteCollection: false,
    collectionToEdit: {},
    collectionToDelete: {},
    loadingEditCollection: false,
    loadingDeleteCollection: false,
    arrSpeed: [],
    count: 0,
    focusinput: false,
    menuWidth: "388px",
    viewerStyleLoaded: false,
    yandexMetricaInitialized: false,
    yandexMetricaBootstrapAttached: false,
    yandexMetricaFallbackTimer: null,
  }),
  computed: {
    ...mapState(useAppStore, {
      initRoute: (state) => state.initRoute,
    }),
    ...mapState(useCollectionsStore, {
      collections: (state) => state.collections,
    }),
    ...mapState(useUserStore, {
      isAuthorized: (state) => state.isAuthorized,
      userInfo: (state) => state.user,
    }),
    ...mapState(useTeamStore, {
      myTeam: (state) => state.myTeam,
    }),
    isDev() {
      return import.meta.env.DEV;
    },
  },
  watch: {
    isAuthorized(val) {
      if (val) {
        this.getTeams();
        this.startRefreshTimer();
        this.getSubscription();
        this.getPlans();
        // TODO: Убрать в будущем если не будем использовать.
        // Запрашиваем плейлист с обучением
        // getYoutubePlaylist(this.$config).then((resp) => {
        //   this.setYoutubeFlag(resp);
        // });
      } else {
        this.stopRefreshToken();
      }
    },
    searchProductsValue(newVal) {
      if (newVal === "") {
        useProductsStore().SET_VALUE({
          key: "searchProducts",
          value: null,
        });
      } else {
        useProductsStore().SET_VALUE({
          key: "searchProducts",
          value: newVal,
        });
      }
    },
  },
  mounted() {
    this.initYandexMetricaOnFirstInteraction();

    if (this.isAuthorized && this.refreshTimer === null) {
      // this.getTeams();
      this.startRefreshTimer();
      this.refreshTokenMix(); // закомментил, потому что и так в main.js обновится
      this.getSubscription();
      this.getPlans();
      // TODO: Убрать в будущем если не будем использовать.
      // Запрашиваем плейлист с обучением
      // getYoutubePlaylist(this.$config).then((resp) => {
      //   this.setYoutubeFlag(resp);
      // });
    }
    // Скачивание стилей
    this.loadViewerStyle();
  },
  beforeUnmount() {
    this.cleanupYandexMetricaBootstrap();
  },
  methods: {
    runWhenIdle(callback, timeout = 2000) {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(
          () => {
            callback();
          },
          { timeout }
        );
        return;
      }

      setTimeout(callback, 0);
    },
    cleanupYandexMetricaBootstrap() {
      const passiveOptions = { passive: true };

      window.removeEventListener("pointerdown", this.startYandexMetricaBootstrap, passiveOptions);
      window.removeEventListener("keydown", this.startYandexMetricaBootstrap);
      window.removeEventListener("touchstart", this.startYandexMetricaBootstrap, passiveOptions);
      window.removeEventListener("wheel", this.startYandexMetricaBootstrap, passiveOptions);

      if (this.yandexMetricaFallbackTimer) {
        clearTimeout(this.yandexMetricaFallbackTimer);
        this.yandexMetricaFallbackTimer = null;
      }

      this.yandexMetricaBootstrapAttached = false;
    },
    startYandexMetricaBootstrap() {
      this.cleanupYandexMetricaBootstrap();
      this.runWhenIdle(() => {
        this.initYandexMetrica();
      });
    },
    initYandexMetricaOnFirstInteraction() {
      if (!import.meta.env.PROD || this.yandexMetricaInitialized || this.yandexMetricaBootstrapAttached) {
        return;
      }

      if (!this.$config || !this.$config.YANDEX_METRICA_ID) {
        return;
      }

      this.yandexMetricaBootstrapAttached = true;

      const passiveOptions = { passive: true };

      window.addEventListener("pointerdown", this.startYandexMetricaBootstrap, passiveOptions);
      window.addEventListener("keydown", this.startYandexMetricaBootstrap);
      window.addEventListener("touchstart", this.startYandexMetricaBootstrap, passiveOptions);
      window.addEventListener("wheel", this.startYandexMetricaBootstrap, passiveOptions);

      this.yandexMetricaFallbackTimer = setTimeout(() => {
        this.startYandexMetricaBootstrap();
      }, 3000);
    },
    initYandexMetrica() {
      if (this.yandexMetricaInitialized) {
        return;
      }

      // Yandex.Metrika counter
      if (this.$config && this.$config.YANDEX_METRICA_ID) {
        console.log("Initializing Yandex Metrica with ID:", this.$config.YANDEX_METRICA_ID);
        (function (m, e, t, r, i, k, a) {
          m[i] =
            m[i] ||
            function () {
              (m[i].a = m[i].a || []).push(arguments);
            };
          m[i].l = 1 * new Date();
          for (var j = 0; j < document.scripts.length; j++) {
            if (document.scripts[j].src === r) {
              return;
            }
          }
          ((k = e.createElement(t)),
            (a = e.getElementsByTagName(t)[0]),
            (k.async = 1),
            (k.src = r),
            a.parentNode.insertBefore(k, a));
        })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        window.ym(this.$config.YANDEX_METRICA_ID, "init", {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
        });

        this.yandexMetricaInitialized = true;
      } else {
        console.warn("Yandex Metrica ID not found in config");
      }
    },
    loadViewerStyle() {
      if (!this.$config || !this.$config.ZARBO_VIEWER_STYLE || this.viewerStyleLoaded) {
        return;
      }

      const viewerStyleHref = new URL(this.$config.ZARBO_VIEWER_STYLE, window.location.origin).href;
      const existingStyle = Array.from(
        document.querySelectorAll('link[data-zarbo-viewer-style="true"]')
      ).find((link) => link.href === viewerStyleHref);

      if (existingStyle) {
        this.viewerStyleLoaded = true;
        return;
      }

      var style = document.createElement("link");
      style.href = viewerStyleHref;
      style.rel = "preload";
      style.as = "style";
      style.setAttribute("data-zarbo-viewer-style", "true");
      style.onload = function () {
        this.onload = null;
        this.rel = "stylesheet";
      };
      document.head.appendChild(style);

      this.viewerStyleLoaded = true;
    },
    async getTeams() {
      if (this.myTeam) {
        return;
      }
      try {
        await initializeTeamContext({ mergePermissions: this.mergePermissionsMix, config: this.$config });
      } catch (error) {
        console.error("Fail get teams", error);
      }
    },
    // TODO: Убрать в будущем если не будем использовать.
    setYoutubeFlag(respData) {
      const lastOpenYoutubePlaylist = localStorage.getItem("lastOpenYoutubePlaylist");

      if (respData.items && respData.items.length !== 0) {
        if (lastOpenYoutubePlaylist) {
          respData.items.forEach((video) => {
            if (video.snippet.publishedAt > lastOpenYoutubePlaylist) {
              useAppStore().SET_VALUE({
                key: "isNewVideoOnYoutubePlaylist",
                value: true,
              });
            }
          });
        } else {
          useAppStore().SET_VALUE({
            key: "isNewVideoOnYoutubePlaylist",
            value: true,
          });
        }
      }
    },
    createProduct() {
      let value = useProductsStore().triggerCreateProduct;
      value++;
      useProductsStore().SET_VALUE({
        key: "triggerCreateProduct",
        value: value,
      });
    },

    searchProducts() {
      useProductsStore().SET_VALUE({
        key: "searchProductsForce",
        value: true,
      });
    },

    async editCollection(collection) {
      const url = this.$config.BASE_URL + "/api/v1/collections/" + collection.id + "/";
      try {
        this.loadingEditCollection = true;
        await this.$axios.patch(url, collection);
        this.isConfirmEditCollection = false;
        this.$notify({
          group: "foo",
          title: "Редактирование коллекции",
          text: "Коллекция <b>" + collection.name + "</b> успешно изменена",
          type: "success",
        });
        this.loadingEditCollection = false;
      } catch (error) {
        this.isConfirmEditCollection = false;

        this.handleErrorMix(error, true);
        // this.$notify({
        //   group: "foo",
        //   title: "Удаление коллекции",
        //   text: "Не удалось изменить коллекцию",
        //   type: "error",
        // });
        this.loadingEditCollection = false;
      }
    },
    startRefreshTimer() {
      this.refreshTimer = setInterval(
        () => {
          this.refreshTokenMix();
        },
        this.refreshInterval * 1000 * 60
      );
    },
    stopRefreshToken() {
      clearInterval(this.refreshTimer);
    },
    async getPlans() {
      const urlPlans = this.$config.BASE_URL + "/api/v1/billing/plans";
      try {
        const resPlans = await this.$axios.get(urlPlans);
        usePermissionsStore().SET_VALUE({
          key: "plans",
          value: resPlans.data,
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getSubscription() {
      let urlSubscription = this.$config.BASE_URL + "/api/v1/billing/subscription";
      if (localStorage.getItem("selectedTeamSlug")) {
        urlSubscription = urlSubscription + "?team=" + localStorage.getItem("selectedTeamSlug");
      }
      try {
        const resSubscription = await this.$axios.get(urlSubscription);
        usePermissionsStore().SET_VALUE({
          key: "subscription",
          value: resSubscription.data,
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss">
.router-container {
  height: 100%;
  width: 100%;
}

.v-pagination__item--active {
  box-shadow: inherit !important;
}

.v-pagination__item {
  box-shadow: inherit !important;
  border: 1px solid rgb(var(--v-theme-border-light));
}

.v-pagination__navigation {
  box-shadow: inherit !important;
  border: 1px solid rgb(var(--v-theme-border-light));
}

.admin-menu {
  box-shadow: none !important;
  background: rgb(var(--v-theme-primary)) !important;
  border-radius: 0 0 10px 10px !important;
  overflow: hidden;

  hr {
    display: none;
  }

  .v-list {
    background: rgb(var(--v-theme-primary)) !important;
    border-radius: 10px;
    padding: 0;
  }

  .v-list-item__title {
    color: white;
    font-weight: 400;
    font-size: 16px;
  }

  .v-list-item {
    &:hover {
      background: #12133a;
    }

    &::before {
      opacity: 0 !important;

      &:hover {
        opacity: 0 !important;
      }

      &:active {
        opacity: 0 !important;
      }
    }
  }
}

.admin-btn {
  width: auto !important;

  span {
    text-transform: none;
    color: #ffffff !important;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }

  &::before {
    opacity: 0 !important;

    &:hover {
      opacity: 0 !important;
    }

    &:active {
      opacity: 0 !important;
    }
  }
}

.v-card__title {
  word-break: break-word;
}

.unselectable {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  -khtml-user-select: none;
  /* Konqueror */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  not supported by any browser */
}

.logo {
  max-height: 38px; // новогоднее лого
}

.gradient-button {
  box-sizing: border-box;
  // width: 190px;
  padding: 0 15px;
  height: 40px;
  background-color: rgb(var(--v-theme-accent)); // primary
  color: white !important;
  position: relative;
  border-radius: 10px;
  border: none;
  overflow: hidden;
  font-size: 16px;
}

.gradient-button::before {
  box-sizing: border-box;
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  width: inherit;
  height: inherit;
  border: 5px solid;
  border-radius: 10px;
  border-top-width: 0;
  border-bottom-width: 0;
  border-image: linear-gradient(0deg, #e94309, #e92a6e, #a204e8) 1;
  // z-index: -1;
}

.block-btn {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  /*Необязательно, но мб надо будет*/
  width: fit-content;
}

.mybtn {
  transform-style: preserve-3d;
  padding: 11px 10px;
  outline: none;
  border: none;
  width: calc(100% + 10px);
  background: rgb(var(--v-theme-accent));
  border: 2px solid rgb(var(--v-theme-accent));
  box-sizing: border-box;
  border-radius: 10px;
  flex: none;

  display: flex;
  align-items: center;
  justify-content: center;

  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
}

.mybtn__size {
  padding-left: 21px !important;
  padding-right: 21px !important;
}

.mybtn::before {
  content: "";
  display: block;
  position: absolute;
  width: calc(100% + 12px);
  height: calc(100% + 4px);
  background: linear-gradient(180deg, #e94309 2.42%, #e92a6e 36.36%, #a204e8 73.08%);
  border-radius: 12px;
  top: -2px;
  z-index: -1;
}

.mybtn::after {
  background: rgb(var(--v-theme-accent));
  content: "";
  display: block;
  position: absolute;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  border-radius: 12px;
  z-index: -1;
}

.mybtn:hover {
  width: calc(100% + 1px);
  transition: all 0.3s;
}

.mybtn:hover::before {
  width: calc(100% + 21px);
  transition: all 0.3s;
}

.mybtn:active {
  width: 100%;
  transition: all 0.3s;
}

.mybtn:active::before {
  width: calc(100% + 10px);
  transition: all 0.3s;
}

.mybtn:disabled {
  height: 43px;
  border: 0;
  background: #9191a8;
}

.mybtn:disabled::before {
  top: 0;
  height: 100%;
  background: linear-gradient(159.37deg, #f4a184 2.42%, #f394b8 36.36%, #d081f3 73.08%);
}

.mybtn:disabled:hover {
  width: calc(100% + 12px);
  transition: none;
}

.mybtn:disabled:hover::before {
  width: calc(100% + 10px);
  transition: none;
}

.card-full-height {
  height: calc(100vh - 113px);
  min-height: calc(100vh - 114px);
  max-height: calc(100vh - 112px);

  .v-card__text {
    height: calc(100% - 130px);
  }
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid rgb(var(--v-theme-border-light));

  &__buttons {
    display: flex;
  }

  &__left {
    display: flex;
    align-items: center;
  }

  &__right {
    display: flex;
    align-items: center;

    &:nth-child(3) {
      margin-right: 800px;
    }
  }

  .total-item {
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    text-decoration: underline;

    &.active {
      color: rgb(var(--v-theme-text-main)) !important;
      text-decoration: none;
    }
  }
}

zarbo-widget #qr-button::before {
  box-sizing: content-box;
}

.custom-icon {
  fill: currentColor;
}

// Scroll for Chrome, Edge и Safari
//* {
//  scrollbar-width: thin;
//}
//*::-webkit-scrollbar {
//  width: 8px;
//}
//*::-webkit-scrollbar-track {
//  // background: rgb(var(--v-theme-bg-gray));
//  // background: white !important;
//  // margin-block: -10px;
//  border-radius: 4px;
//}
//*::-webkit-scrollbar-thumb {
//  width: 8px;
//  // background: rgb(var(--v-theme-secondary));
//  border-radius: 4px;
//}
// Scroll for Firefox
//* {
//  scrollbar-width: thin;
//  scrollbar-color: rgb(var(--v-theme-secondary)) rgb(var(--v-theme-secondary));
//}
// Цвет букв внутри v-select, v-autocomplete, v-text-field & etc...
.v-select__selection,
.v-select__selection-text,
.v-autocomplete__selection,
.v-autocomplete__selection-text,
.v-select.v-text-field input,
.v-autocomplete.v-text-field input,
.v-text-field input {
  color: rgb(var(--v-theme-primary)) !important;
}

.icon-block__input {
  border-radius: 10px !important;
  max-width: 576px !important;

  fieldset {
    border: 1px solid rgb(var(--v-theme-bg-gray)) !important;
  }
}

.email-support {
  position: absolute;
  bottom: 5px;
  right: 10px;
}

.footer {
  @include media("max", "576") {
    font-size: 14px;
  }
}
</style>
